export default "__VITE_ASSET__9FJd3wuF__"